import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import backicon from "../../../../../Assets/icons/backIcon.svg"
import axiosInstance from '../../../../services/api/API';
import { format } from 'date-fns';


const UpdatePhysicalStockTaking = () => {

  const [ userTypedd, setUserTypedd ] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [ physicalStockTakingList, setPhysicalStockTakingList ] = useState([])
  const [ vendorName, setVendorName ] = useState([])

  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const token = localStorage.getItem("authToken");

  const location = useLocation();
  const { data } = location.state || {};
  const formatDateToYYYYMMDD = (dateString) => {
    console.log("dateString",dateString);
    
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    userTypedropdown()
  },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  useEffect(() => {
    vendorNameList()
  },[])

  const vendorNameList = async () => {
    try{
      const response = await axiosInstance.post("/vendor/ddlvendorlist",{
        business_partner_id: 1,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response.data.data
      const vendorNameOptions = data.map(user => ({
        value: user.ID,
        label:user.NAME,
      }))
      setVendorName(vendorNameOptions)
    }catch(error) {
      console.log(error)
    }
  }

  const [formData, setFormData] = useState({});


  // Add states for table data 
  const [tableData, setTableData] = useState([]); 

  const navigate = useNavigate();

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    setIsLoading(true);
    console.log("formData",formData);
    try {

   const formattedDOB=format(formData.trn_date,"yyy-MM-dd")
   const formatJD = format(formData.ref_date,"yyy-MM-dd")
 
    const payload = {
        trn_no:formData.trn_no,
    vendor_id:formData.vendor_id,
    trn_date: formattedDOB,
    ref_no: formData.ref_no,
    ref_date: formatJD,
    trn_total:formData.trn_total,
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.patch(`/physicalstocktake/update/${data.phystkin_id}`, payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      }
    );
  
      console.log("Unit added successfully:", response.data);

      navigate('/logistics/manage-stock/physical-stock-taking'); 
    } catch (error) {
      console.error('Error adding data:', error);

      console.error("Error submitting form:", error);
    } finally {
      setIsLoading(false);
    }
    console.log("clicked")
  };

  useEffect(() => {
    fetchPhysicalStockTakingListEdit()
  },[])


  const fetchPhysicalStockTakingListEdit = async () => {
    try{
      const response = await axiosInstance.get(`/physicalstocktake/edit/${data.phystkin_id}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    })
    const fetchedData = response.data.data[0];
    const formattedrefDate = formatDateToYYYYMMDD(fetchedData?.ref_date);
    const formattedtrnDate = formatDateToYYYYMMDD(fetchedData?.trn_date);
    console.log(formattedtrnDate, "formattedtrnDate")
    const transformedData = {
    vendor_id:fetchedData.vendor_id,
    trn_no:fetchedData.trn_no,
    trn_date:formattedtrnDate,
    ref_no:fetchedData.ref_no,
    ref_date:formattedrefDate,
    trn_total:fetchedData.trn_total,
    business_partner_id:fetchedData.business_partner_id,
    }
    setFormData(transformedData)
    setPhysicalStockTakingList(fetchedData)
    console.log(formData, "depatartment DATA")
  
  }catch(error){
      console.log(error)
    }
  
  }


  const CustomerInputs = [
    ...(userType === "superadmin"
        ? [
            {
              name: "business_partner_id",
              label: "Business Partner",
              type: "dropdown",
              required: true,
              options: userTypedd,
              gridClass: "col-lg-4",
              validation: {
                required: true,
                pattern: /^[A-Za-z0-9 ]*$/,
                message: "Only alphabets and digits are allowed",
              },
            },
          ]
        : []),
        {
            name: "vendor_id",
            label: "Vendor Name",
            type: "dropdown",
            options: vendorName,
            required: true,
            gridClass: "col-lg-4",
          },
  {
    name: "trn_no",
    label: "Transaction No.",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    disabled:true
  },
  {
    name: "trn_date",
    label: "Transaction Date",
    type: "date",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "ref_no",
    label: "Reference No.",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  { 
    name: "ref_date",
    label: "Reference Date",
    type: "date",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "trn_total",
    label: "Transaction Total ",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    disabled:true
  },
];

const backNavigate = () => {
navigate("/logistics/manage-stock/physical-stock-taking")
}

  return (
    <div>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
        <div className="backbutton mt-2 mb-2" style={{width:"100%"}} >
        <img onClick={backNavigate} src={backicon} alt="back" />
        <span className="backbtntitle">Edit Physical Stock Taking</span>
      </div>


      <div className="btncontainer mt-3 gap-2">
        {/* <button
        onClick={() => handleFormSubmit(formData)}
          className="submit-btn" style={{marginRight:"16px"}}
        >
          Submit
        </button> */}

        <button
        onClick={() => {handleFormSubmit(formData)}}className="submit-btn">
        Update
        </button>
      </div>

      </div>
      <div className="form-container">
        {/* <div className="d-flex flex-row justify-content-between" style={{marginBottom:"25px"}}>
            <div>
        <span className="cust-det-title mt-2 mb-2">
          Add
        </span>
            </div>
        </div> */}
        <p style={{fontSize:"20px", color:"grey"}}>Please update stock details</p>
        <DynamicForm
        formConfig={CustomerInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        />

      </div>
    </div>
  )
}

export default UpdatePhysicalStockTaking;